<template>
  <v-navigation-drawer
    absolute
    temporary
    v-model="sidebarState"
    width="350"
    v-if="currentWorkspace && currentWorkspace.id"
  >
    <div class="pa-3">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-card flat v-on="on">
            <v-layout v-if="currentWorkspace && Object.entries(currentWorkspace).length !== 0">
              <workspace-avatar
                class="mt-4"
                color="grey lighten-2"
                :workspace="currentWorkspace"
              ></workspace-avatar>
              <v-col>
                <v-layout column>
                  <v-col class="title pa-0">{{ workspaceProfile.name }}</v-col>
                  <v-col class="caption pa-0"
                    >{{ currentWorkspace.subscriptionInfo.currentPlan }} |
                    {{ Object.keys(currentWorkspace.members).length }} Users</v-col
                  >
                  <v-col class="caption pa-0">
                    <v-dialog v-model="settingsModal" persistent max-width="800px">
                      <template v-slot:activator="{ on: { click } }">
                        <v-btn x-small text @click.stop="click">Settings</v-btn>
                      </template>
                      <workspace-settings
                        :item="currentWorkspace"
                        :show="settingsModal"
                        @close="settingsModal = false"
                      ></workspace-settings>
                    </v-dialog>
                  </v-col>
                </v-layout>
              </v-col>
              <v-col class="shrink">
                <v-icon large>arrow_drop_down</v-icon>
              </v-col>
            </v-layout>
          </v-card>
        </template>
        <v-list>
          <v-list-item
            v-for="workspace in workspaces"
            :key="workspace.id"
            exact
            :to="{ name: 'dashboard', params: { workspaceId: workspace.id } }"
            @click="setWorkspaceId(workspace.id)"
          >
            <v-list-item-avatar class="mt-0">
              <workspace-avatar :workspace="workspace" color="grey lighten-2"></workspace-avatar>
            </v-list-item-avatar>
            <v-list-item-title>{{ workspace.profile.name }}</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item @click.stop>
            <explorer-new-workspace @create="createWorkspace"></explorer-new-workspace>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <v-divider></v-divider>
    <v-list>
      <v-list-item exact :to="{ name: 'dashboard', params: { workspaceId: currentWorkspace.id } }">
        <v-list-item-avatar class="mt-0">
          <v-icon small>dashboard</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>My Dashboard</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item exact :to="{ name: 'contexts', params: { workspaceId: currentWorkspace.id } }">
        <v-list-item-avatar class="mt-0">
          <c-icon icon="context" size="16" color="grey darken-1"></c-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>All Contexts</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- <v-list-item avatar @click="">
        <v-list-item-avatar class="mt-0">
          <v-icon small>developer_board </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Projects</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
      <v-list-item exact :to="{ name: 'resources', params: { workspaceId: currentWorkspace.id } }">
        <v-list-item-avatar class="mt-0">
          <v-icon small>receipt </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Resources</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <div class="pa-2">
      <v-autocomplete
        filled
        rounded
        dense
        hide-details
        prepend-inner-icon="search"
        label="Search Contexts"
        :items="workspaceContexts"
        item-text="text"
        item-value="id"
        @change="$router.push({ name: 'context', params: { contextId: $event } })"
      >
        <template v-slot:item="data">
          <template>
            <v-list-item-avatar> </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="data.item.text"></v-list-item-title>
            </v-list-item-content>
          </template>
        </template>
      </v-autocomplete>
    </div>
    <v-list dense v-if="sidebarState">
      <v-subheader class="py-0 my-0 pr-0">
        My Recently Opened Contexts
        <v-spacer></v-spacer>
      </v-subheader>
      <v-list-item
        v-for="context in recentContexts"
        :key="context.id"
        :to="{ name: 'context', params: { contextId: context.id } }"
      >
        <v-list-item-avatar class="mt-0 mr-2">
          <c-icon icon="context" size="16" color="grey lighten-1"></c-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ context.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list dense>
      <v-subheader class="py-0 my-0 pr-0">
        My Current Contexts
        <v-spacer></v-spacer>
      </v-subheader>
      <v-list-group
        sub-group
        value="true"
        v-for="project in contextsByProject.projects"
        :key="project.id"
      >
        <template v-slot:activator>
          <v-list-item-avatar class="mt-0 mr-2">
            <v-icon small>developer_board</v-icon>
          </v-list-item-avatar>
          <v-list-item-title>{{ project.id }}</v-list-item-title>
          <v-list-item-icon>
            <v-avatar size="16" color="blue lighten-4">{{ project.contexts.length }}</v-avatar>
          </v-list-item-icon>
        </template>
        <v-list-item
          v-for="context in project.contexts"
          :key="context.id"
          :to="{ name: 'context', params: { contextId: context.id } }"
        >
          <v-list-item-avatar class="mt-0 mr-2">
            <c-icon icon="context" size="16" color="grey lighten-1"></c-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ context.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-list-item
        v-for="context in contextsByProject.other"
        :key="context.id"
        :to="{ name: 'context', params: { contextId: context.id } }"
      >
        <v-list-item-avatar class="mt-0 mr-2">
          <c-icon icon="context" size="16" color="grey lighten-1"></c-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ context.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-btn text><v-icon>add</v-icon> new context</v-btn>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

import ExplorerNewWorkspace from './ExplorerNewWorkspace';
import WorkspaceAvatar from '@/components/WorkspaceAvatar';
import WorkspaceSettings from '@/components/Explorer/WorkspaceSettings';

export default {
  components: {
    ExplorerNewWorkspace,
    WorkspaceAvatar,
    WorkspaceSettings
  },
  data: () => ({
    settingsModal: false,
    loadingWorkspace: false,
    c: window.console
  }),
  mounted() {
    //  Here we will handle setting the workspace
  },
  watch: {
    $route: function(n, o) {
      if (!this.currentWorkspaceId) {
        console.log(this.allUserDocuments);
        console.log('no current workspace');
        //  No workspace set yet, we need to set one
        //  First check the route props
        console.log(this.$route, this.$route.params.workspaceId);
        if (this.$route.params.workspaceId) {
          console.log('params');
          this.setWorkspace(this.$route.params.workspaceId);
        } else if (this.$route.name == 'context') {
          //&& this.userIsWorkspaceMember
          if (Object.keys(this.allUserDocuments).length) {
            const contextId = this.$route.params.contextId;
            const contextData = this.allUserDocuments[contextId];
            this.setWorkspace(contextData.workspace);
          } else {
            this.loadingWorkspace = true;
          }
          //  Check if we are in a context
          //  Get the workspace from the context data
          //  Not sure what to do here if we are not in the workspace
        } else if (this.lastWorkspaceId) {
          //  try to get the workspace from last opened workspace
          console.log('there is a last workspace id');
          this.setWorkspace(this.lastWorkspaceId);
        } else if (this.userWorkspaceLiteData && Object.values(this.userWorkspaceLiteData)[0]) {
          console.log('set first workspace');
          const workspaceId = Object.values(this.userWorkspaceLiteData)[0].workspaceId;
          this.setWorkspace(workspaceId);
        } else {
          console.log('couldnt set workspace');
          // failed to load it yet.
          this.loadingWorkspace = true;
        }
      } else if (n.params.workspaceId && n.params.workspaceId != this.currentWorkspaceId) {
        this.setWorkspace(this.$route.params.workspaceId);
      }
    },
    fetchingUserData: function(n, o) {
      if (!n && this.loadingWorkspace && !this.currentWorkspaceId) {
        console.log('retry setting workspace');
        //  We just finished fetching user data and previously failed to set workspace
        //  try again
        if (this.$route.name == 'context' && Object.keys(this.allUserDocuments).length) {
          console.log('tis a context');
          const contextId = this.$route.params.contextId;
          const contextData = this.allUserDocuments[contextId];
          this.setWorkspace(contextData.workspace);
        } else if (this.lastWorkspaceId) {
          console.log('set to last workspace id');
          //  try to get the workspace from last opened workspace
          this.setWorkspace(this.lastWorkspaceId);
        } else if (this.userWorkspaceLiteData && Object.values(this.userWorkspaceLiteData)[0]) {
          console.log('set first workspace');
          const workspaceId = Object.values(this.userWorkspaceLiteData)[0].workspaceId;
          this.setWorkspace(workspaceId);
        } else {
          // failed to load it yet.
          this.loadingWorkspace = true;
        }
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['isUser', 'lastWorkspaceId']),
    // ...mapGetters('userWorkspaceLite', ['allUserDocuments']),
    ...mapGetters('context', ['userIsWorkspaceMember', 'context']),
    ...mapState('auth', ['fetchingUserData']),
    ...mapGetters('workspaces', [
      'workspaces',
      'currentWorkspace',
      'guestWorkspaces',
      'workspaceContexts'
    ]),
    ...mapState('components/explorerSidebar', ['value']),
    ...mapState('userWorkspaceLite', ['userWorkspaceLiteData', 'allUserDocuments']),
    ...mapState('workspaces', ['currentWorkspaceId']),
    sidebarState: {
      get: function() {
        return !this.isUser ? false : this.value;
      },
      set: function(v) {
        this.toggleSidebar(v);
      }
    },
    workspaceProfile() {
      return this.currentWorkspace.profile || {};
    },
    recentContexts() {
      const w = this.workspaceContexts.filter(c => c.lastOpenedByUser != null);
      console.log(w);
      return w
        .sort((a, b) => {
          const aDate =
            typeof a.lastOpenedByUser.toDate == 'function'
              ? a.lastOpenedByUser.toDate()
              : a.lastOpenedByUser.toDate;
          const bDate =
            typeof b.lastOpenedByUser.toDate == 'function'
              ? b.lastOpenedByUser.toDate()
              : b.lastOpenedByUser.toDate;
          if (aDate < bDate) {
            return 1;
          } else {
            return -1;
          }
        })
        .slice(0, 4);
    },
    currentContexts() {
      console.log('currentCotnexts');
      return this.workspaceContexts.filter(d => d.type == 'context' && d.userStatus == 'current');
    },
    contextsByProject() {
      console.log('get contexts by project');
      const projects = {};
      const other = [];
      this.currentContexts.forEach(c => {
        const project = c.project;
        if (project) {
          if (projects[project]) {
            projects[project].contexts.push(c);
          } else {
            projects[project] = { id: project, contexts: [c] };
          }
        } else {
          other.push(c);
        }
      });
      console.log(Object.values(projects), other);
      return { projects, other };
    }
  },
  methods: {
    ...mapActions('workspaces', ['createNewWorkspace', 'setWorkspaceId']),
    ...mapMutations('components/explorerSidebar', ['toggleSidebar']),
    ...mapMutations('components/settingsModal', ['setModal']),
    createWorkspace(event) {
      this.createNewWorkspace(event)
        .then(newId => {
          this.setWorkspaceId(newId);
        })
        .catch(e => console.log(e));
    },
    setWorkspace(workspaceId) {
      this.$router.push({
        params: { workspaceId }
      });
      this.setWorkspaceId(workspaceId);
      this.loadingWorkspace = false;
    }
  }
};
</script>

<style></style>
